/*
 * @Author: redu125 alSZBayxDwQnKd60.redu125@noreply.gitcode.com
 * @Date: 2026-08-27 19:35:55
 * @LastEditors: redu125 alSZBayxDwQnKd60.redu125@noreply.gitcode.com
 * @LastEditTime: 2026-08-28 10:38:02
 * @FilePath: \watherfocast2\src\utils\request.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from 'axios'
import { Message } from 'element-ui'
import { getToken, clearAuth, isSilentOnAuthFail } from './auth'

// 认证类提示去重：并发请求同时返回 401/403 时只弹一个提示框
const AUTH_MESSAGE_INTERVAL = 2000
let lastAuthMessageAt = 0
function showAuthMessageOnce(text) {
  if (isSilentOnAuthFail()) return
  const now = Date.now()
  if (now - lastAuthMessageAt < AUTH_MESSAGE_INTERVAL) return
  lastAuthMessageAt = now
  Message.error(text)
}

// 判断是否为认证类错误（401/403）：已由全局拦截器统一提示并跳转，页面级 catch 不再重复提示
export function isAuthError(error) {
  const status = error && error.response && error.response.status
  return status === 401 || status === 403
}

// 统一请求拦截：为所有 axios 请求附加 JWT
axios.interceptors.request.use(
  config => {
    const url = (config.url || '').toLowerCase()
    // 登录接口无需（也不应）携带 token
    if (url.indexOf('/login') !== -1) {
      return config
    }
    // 站点列表接口无需携带 token
    if (url.indexOf('/api/hydro/stations') !== -1) {
      return config
    }
    // 静态资源请求（json、图片等非 API 路径）不注入 token
    if (url.indexOf('/api/') === -1) {
      return config
    }
    const token = getToken()
    if (token) {
      config.headers = config.headers || {}
      // lsserver 的 sky.jwt.token-name 配置为 token，直接传 JWT。
      config.headers.token = token
    }
    return config
  },
  error => Promise.reject(error)
)

// 统一响应拦截：处理 401 / 403
axios.interceptors.response.use(
  response => response,
  error => {
    const status = error.response && error.response.status
    const url = (error.config && error.config.url) || ''

    if (status === 401 && url.indexOf('/login') === -1) {
      clearAuth()
      showAuthMessageOnce('登录已过期，请重新登录')
      if (window.location.hash !== '#/login') {
        window.location.hash = '#/login'
      }
    } else if (status === 403) {
      showAuthMessageOnce('当前账号无权访问该水电站')
    }
    return Promise.reject(error)
  }
)

export default axios
